<template>
  <div>
    <div v-if="loadingList">
      <AppSkeletonCardField :cols="4" :rows="1"></AppSkeletonCardField>
    </div>
    <div v-else class="p-grid" v-for="result in results" :key="result.id">
      <div class="p-col-12">
        <a href="#">
          <VetCard :model="result" @click="showEdit(result)" />
        </a>
      </div>
    </div>
    <div>
      <VetDialog
        v-model:visible="modalVisible"
        :initialData="modalData"
        @invite="fetchList()"
        @remove="fetchList()"
      ></VetDialog>
      <AppFloatButton icon="pi pi-plus" @click="showAdd()" />
    </div>
  </div>
</template>

<script>
import useApiList from '../../lib/useApiList';
import { VetApi } from '../../services/api';
import VetCard from './components/VetCard.vue';
import VetDialog from './components/VetDialog.vue';

export default {
  name: 'VetList',
  components: {
    VetCard,
    VetDialog,
  },
  setup() {
    const apiList = useApiList(VetApi);
    return { ...apiList };
  },
  data() {
    return {
      modalVisible: false,
      modalData: null,
    };
  },
  async created() {
    await this.fetchList();
  },
  methods: {
    showAdd() {
      this.modalVisible = true;
      this.modalData = null;
    },
    showEdit(data) {
      this.modalVisible = true;
      this.modalData = data;
    },
  },
};
</script>

<style lang="css" scoped>
#loading >>> .p-card-content {
  padding: 0 !important;
}
</style>
